import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CheckoutButton } from './CheckoutButton';
import { checkoutUrl, productImage } from '../data/content';
export function PricingCard() {
  return <section id="pricing" className="scroll-mt-0 bg-brand-navy px-4 py-5 text-white sm:px-6" aria-labelledby="offer-heading" data-id="element-120" data-mp="1m3j9z72vwg3n">
      <div className="mb-3 text-center" data-id="element-121" data-mp="1i4smlro80ctq">
        <p className="mb-1 text-[11px] font-extrabold uppercase tracking-widest text-brand-green" data-id="element-122" data-mp="2eti1ra8gqrc0">
          Special Launch Offer
        </p>
        <h2 id="offer-heading" className="mb-0.5 text-xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-123" data-mp="29uf6ghiabzh8">
          Pickleball Coach Pro™
        </h2>
        <p className="mb-2 text-[12px] font-bold sm:text-sm" data-id="element-124" data-mp="210sfr5sxpmew">
          Complete 6-in-1 Coaching &amp; Training System
        </p>
        <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block focus:outline-none focus:ring-2 focus:ring-brand-green" data-id="element-125" data-mp="2xlkpt6nfp9wa">
          <img src={productImage} alt="Pickleball Coach Pro complete system" className="mx-auto w-full max-w-[240px] object-contain drop-shadow-[0_16px_36px_rgba(0,0,0,0.5)] transition-transform duration-200 hover:scale-[1.02]" data-id="element-126" data-mp="32mf845vj5bro" />
        </a>
      </div>
      <div className="mx-auto max-w-md rounded-xl border-2 border-brand-green bg-white p-3.5 text-center text-brand-ink shadow-2xl" data-id="element-127" data-mp="2xrj3m693wvxo">
        <ul className="mb-2 space-y-0.5 text-[12px] font-bold text-brand-navy sm:text-sm" data-id="element-128" data-mp="2oso051xg5zy2">
          <li data-id="element-129" data-mp="29voliu46h6u3">✅ 6 Professional Modules</li>
          <li data-id="element-130" data-mp="29wyith37iazo">✅ 5 Premium Bonuses</li>
        </ul>
        <p className="text-[12px] font-semibold text-brand-muted" data-id="element-131" data-mp="2eurq6dg8xb1j">
          Regular Price: <span className="line-through" data-id="element-132" data-mp="2ewufev9kr057">$97</span>
        </p>
        <p className="my-1 text-2xl font-extrabold uppercase leading-none text-brand-navy sm:text-3xl" data-id="element-133" data-mp="85lg8yopof6s">
          🔥 Today Only: <span className="text-brand-green" data-id="element-134" data-mp="d2lmb9lk9hxw">$27 USD</span>
        </p>
        <p className="mb-3 text-[10px] font-medium text-brand-muted" data-id="element-135" data-mp="bn94kjaj4tak">
          Secure payment in your local currency.
        </p>
        <CheckoutButton data-id="element-136" data-mp="6ltl2vo02uua">🚀 YES! I WANT MY COMPLETE SYSTEM</CheckoutButton>
        <div className="mt-2 flex flex-col items-center justify-center gap-0.5 text-[11px] font-bold text-brand-navy sm:flex-row sm:gap-4" data-id="element-137" data-mp="1otdggbi5k12">
          <span data-id="element-138" data-mp="3tu70fyyg7rmz">⭐⭐⭐⭐⭐ 4.9/5 — Verified Coach Reviews</span>
          <span className="flex items-center gap-1" data-id="element-139" data-mp="ube4tgrz9w4m">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-green" aria-hidden="true" data-id="element-140" data-mp="pdmbciboq1yb" />
            7-Day Money-Back Guarantee
          </span>
        </div>
      </div>
    </section>;
}